import { getLoginUrl } from '@/util/index';
/**
 * 跳转登录方法
 * @param loginUrl
 */
export const goLogin = (loginUrl = '') => {
    // if (!loginUrl) {
    //     loginUrl = '//ssa.jd.com/sso/login';
    // }
    // const wlh = window.location.href;
    // const url = `${loginUrl}${
    //     loginUrl.indexOf('?') === -1 ? '?' : '&'
    // }returnUrl=${encodeURIComponent(wlh)}`;
    // console.log('=====goLogin--url=====\n', url)
    window.location.href = getLoginUrl();
};

// http请求拦截器
// 添加时间戳 防止缓存
export const addRequestQuery = (config) => {
    if (config.method.toLowerCase() === 'get') {
        const url = config.url;
        const t = new Date().getTime();
        config.url = `${url}${url?.indexOf('?') === -1 ? '?' : '&'}t=${t}`;
    }
    return config;
};

/**
 * 检查是否为函数，如果是函数执行并返回值，如果不是直接返回
 * @param fun
 * @param args
 * @returns {*}
 */
export const checkFunction = (fun, args) => (typeof fun === 'function' ? fun(args) : args);

/**
 * color接口状态码
 * @type {{GATEWAY_ERROR: number, SUCCESS: number, BUSINESS_SERVICE_ERROR: number, NOT_LOGIN: number, NOT_HEADID: number}}
 */
export const BUSINESS_STATUS = {
    GATEWAY_ERROR: -1, // 网关处理异常
    SUCCESS: [200, '0', 0, 'N0000'], // 调用成功
    NOT_HEADID: [601],
    NOT_LOGIN: [401, 'E0050'], // 未登录
    BUSINESS_SERVICE_ERROR: 2, // 业务系统调用失败:服务端错误描述信息
    NO_ACCESS: ['E0010'], // 无权限访问
};

// 请求参数 body 对象默认值
export const DEFAULT_BODY_PARAMS = {
    requestId: new Date().getTime(),
};

/**
 * 白名单检查，当请求hostName 在 WHITELIST 配置中，不添加全局拦截参数；默认是白名单为空，全局添加拦截参数
 * @param config
 * @param defaultParams
 */
export const checkWhitelist = (config = {}, defaultParams = {}) => {
    const { baseUrl: searchItem } = config;

    // baseUrl 是否存在白名单中
    // let hasWhiteUrl = (ADD_REQUEST_WHITELIST || []).find(url => url.indexOf(searchItem) > -1)
    const hasWhiteUrl = true;
    if (hasWhiteUrl) {
        defaultParams = {};
    }
    return defaultParams;
};
